/**
 * Whether an option is the currently selected radio list value.
 * @param {string} value - Current selected option id
 * @param {string} optionId - Option id
 * @returns {boolean}
 */
export function isOptionSelected(value, optionId) {
  return String(value ?? '') === String(optionId);
}
